import React from 'react';
import {Routes, Route} from 'react-router-dom';
import DatabaseServices from './routes/database/database.component';
import ServicesHome from './services-home.component';
import './services.style.scss';

const Services = () => {
  return (
    <div className="services-container">
      <Routes>
        <Route index element={<ServicesHome />} />
        <Route path="database/*" element={<DatabaseServices />} />
      </Routes>
    </div>
  );
};

export default Services;